import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const NeoErgo = () => (
  <ArticleWrapper articleId="neo_ergo">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Neo Ergo</h1>
        <img src="/pictures/gallery/gallery13.JPG" alt="Neo Ergo" className="rounded-lg mb-6" />
        {/* Add your Neo Ergo article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default NeoErgo;
